import "@ids/style-button";
import "@ids/style-card";
import "@ids/style-css-helpers";
import "@ids/style-dropdown-list";
import "@ids/style-error-message";
import "@ids/style-input-field";
import "@ids/style-label";
import "@ids/style-loader";
import "@ids/style-modal-v19";
import "@ids/style-radio-button";
import "@ids/style-scaffolding";
import "@ids/style-segmented-control";
import "@ids/style-dropdown-select";

import BabyEntry from "./baby";
import CatEntry from "./cat";
import ChildEntry from "./child";
import DogEntry from "./dog";
import HouseholderEntry from "./householder";
import TravelEntry from "./travel";

customElements.define("travel-entry", TravelEntry);
customElements.define("householder-entry", HouseholderEntry);
customElements.define("baby-entry", BabyEntry);
customElements.define("child-entry", ChildEntry);
customElements.define("dog-entry", DogEntry);
customElements.define("cat-entry", CatEntry);
